export default __webpack_public_path__ + "static/media/breaks.c3353bd1.png";